import type { WorkbenchWritableFile } from '~/lib/stores/workbench';
import { workbenchStore } from '~/lib/stores/workbench';
import { removeWorkDir } from '~/utils/workDir';

export class FileSystemAdapter {
  async writeFile(filePath: string, file: WorkbenchWritableFile) {
    return workbenchStore.writeFile(removeWorkDir(filePath), file);
  }

  async removeFile(filePath: string) {
    return workbenchStore.removeFile(removeWorkDir(filePath));
  }

  async rmdir(filePath: string) {
    return workbenchStore.removeDirectory(removeWorkDir(filePath));
  }

  async mkdir(filePath: string) {
    return workbenchStore.createDirectory(removeWorkDir(filePath));
  }
}
